import { h } from 'preact';
import React, { Component } from 'react';

import { IOSButtonSettings } from './IOSButtonSettings';
import { makeText, languageUsed, isActionAllowed } from '../../util';
import { actionTypes } from '../../constants';

import './IOSButton.css';

export class IOSButton extends Component {
  makeChoice = (type, settings) => {
    const { language } = this.props;
    this.props.makeChoice(actionTypes[type], languageUsed(language, settings, 'text'))
  }

  render() {
    const settings = new IOSButtonSettings(this.props.component.settings);
    const { language, dev } = this.props;
    const styles = {
      ...settings.padding,
      ...settings.margin,
      ...settings.border,
      ...settings.font
    };

    /* WIDTH & HEIGHT */
    const { paddingLeft, paddingRight } = settings.padding;
    const { marginLeft, marginRight } = settings.margin;

    styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
    if (settings.width.type === '%') {
      styles.width = `calc(${settings.width.value}% - ${(paddingLeft + paddingRight + marginLeft + marginRight)}px`;
    };

    styles.background = settings.background;

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (dev) {
      devActions = { ...dev.hover };
      selected = dev.current === path;
    }

    const className = 'message-component message-button no-children focusable' + this.props.className;
    const btnText = makeText(dev, settings, 'text', language);
    return (
      <button
        tabIndex={settings.startFocus ? 1 : 0}
        title={btnText}
        aria-label={btnText}
        onClick={() => this.makeChoice(settings.action_type, settings)}
        onKeyDown={(e) => isActionAllowed(e.key) && this.makeChoice(settings.action_type)}
        className={selected ? className + ' on-active' : className}
        path={dev ? path : null}
        style={styles}
        {...devActions}
      >
        {btnText}
      </button>
    );
  }
}